import React, {useEffect} from 'react';
import {connect, useSelector} from 'react-redux';
import {resetUser} from '../../store/actions/user.actions';
import {resetView} from '../../store/actions/view.actions';
import SMCPageLoading from '../../components/core/pageComponents/SMCPageLoading';
import Api from '../../api/SMPFetchHelper';
import {SMCPaths} from '../../conf/Routes';
import {isAuthenticatedSelector} from '../../store/selectors/user.selectors';

function LogoutHandler({
    resetUser,
    resetView
}) {
    const loggedIn = useSelector(isAuthenticatedSelector);

    useEffect(() => {
        if (loggedIn) {
            resetUser();
            resetView();
            Api.logout()
            .finally(() => {
                // Use window.location.href to make the application refresh on each logout
                window.location.href = SMCPaths.login
            });
        }
        else {
            // Use window.location.href to make the application refresh on each logout
            window.location.href = SMCPaths.login;
        }
    });

    return (
        <SMCPageLoading />
    );
}

const mapStateToProps = null;

const mapDispatchToProps = {
    resetUser,
    resetView
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoutHandler);